import { Component,OnInit  } from '@angular/core';
import { NavController } from 'ionic-angular';
import {OrderDetailPage} from '../orderdetail/orderdetail';
import {MyUrlService} from '../home/checkUrll';
import {MydataService} from '../home/mydata.service';
import {JsonData} from '../home/dataaa';
import  { Http } from '@angular/http';
import { LoadingController } from 'ionic-angular';
import {KiloMenuPage} from "../kilomenu/kilomenu";
import {KiloPartyPage} from "../kiloparty/kiloparty";
import {KiloStorePage} from "../kilostore/kilostore";

//import { Device } from '@ionic-native/device';
@Component({
  selector: 'page-orderhistory',
  templateUrl: 'orderhistory.html',
   providers:[MydataService,MyUrlService,JsonData]
})
export class OrderHistoryPage implements OnInit {
	jsonDt : Array<JsonData>;
	orderhistoryDt: Array<JsonData>;
    description:any;
	descriptiones:any;
	myParseInt = parseInt;
	descriptions:any;
  constructor(private http:Http,public loading: LoadingController,public navCtrl: NavController,private mydataService: MydataService,private myurlService: MyUrlService) {}

  ngOnInit(){
	  
	  		
		this.description=window.localStorage.getItem('description_kilomenus');
		//alert(this.description);
		this.descriptiones=window.localStorage.getItem('description_kilopartys');
		//alert(this.descriptiones);
		this.descriptions=window.localStorage.getItem('description_kilostores');
		//alert(this.descriptions);
		
	  if(this.mydataService.checkInternetFunction()=="0"){
    ////console.log("Internet UnAvailable")
    }else  if(this.mydataService.checkInternetFunction()=="1"){

	   let loader = this.loading.create({content: '',});
    var userid = window.localStorage.getItem('userid');
	//alert(userid)
	var kiloSabjiJSONdata = JSON.stringify({"userid":userid});

	   //console.log("Product Url--->"+this.myurlService.ORDERHISTORY+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
	   	loader.present().then(() => {
		this.mydataService.postJSON(this.myurlService.ORDERHISTORY,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.orderDetailService(loader));
  });
	}
		}

	errorFunction= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
		}
  orderDetailService=function(loader){
		 this.orderhistoryDt = this.jsonDt.bookingdata;
		//console.log("bookingdata receive jsondata ==>"+JSON.stringify(this.jsonDt.bookingdata));
		//this.deliverDates=this.orderhistoryDt[0].deliverDate;
		//alert(this.deliverDates);
		//window.localStorage.setItem('deliverDates',this.deliverDates);
		loader.dismiss();
        }


    orderdetial(bookingid)
  {
        window.localStorage.setItem('booking',bookingid);

	   this.navCtrl.push(OrderDetailPage);
  }
  kilomenu(cartid)
	{
		window.localStorage.setItem('localid', cartid );
		//window.localStorage.setItem('subcatid', subcat );
		//var xyz = window.localStorage.getItem('localid');
		
		//alert(cartid)
		if(cartid==1)
		{
			//this.navCtrl.push(KiloMenuPage);
			this.navCtrl.setRoot(KiloMenuPage);
		}
		if(cartid==2)
		{
			//this.navCtrl.push(KiloPartyPage);
			this.navCtrl.setRoot(KiloPartyPage);
		}
		if(cartid==3)
		{
			//this.navCtrl.push(KiloStorePage);
			this.navCtrl.setRoot(KiloStorePage);
		}
		
	}

}



// WEBPACK FOOTER //
// ./src/pages/orderhistory/orderhistory.ts